import React from "react";
import { PageHero } from "@/components/shared/PageHero";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { StaggerGroup, StaggerItem, Reveal } from "@/components/shared/Reveal";
import { ServiceCard } from "@/components/home/ServicesGrid";
import { CTAButton } from "@/components/shared/CTAButton";
import { SERVICES, IMAGES } from "@/data/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        breadcrumb="Services"
        eyebrow="What we do"
        title="Comprehensive logistics solutions."
        description="Twelve specialised services designed to move anything, anywhere — safely, affordably and on time."
        image={IMAGES.truck}
      />

      <section className="bg-white py-24 lg:py-32">
        <div className="container-x">
          <SectionHeading
            align="center"
            className="mb-16"
            eyebrow="Our expertise"
            title="One partner for every logistics need."
            description="Each service is backed by trained teams, insured transit and live tracking."
          />
          <StaggerGroup className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s) => (
              <StaggerItem key={s.title} className="h-full">
                <ServiceCard {...s} />
              </StaggerItem>
            ))}
          </StaggerGroup>
        </div>
      </section>

      {/* CTA band */}
      <section className="bg-surface pb-24 lg:pb-32">
        <div className="container-x">
          <Reveal className="relative overflow-hidden rounded-3xl bg-brand text-white p-10 sm:p-16 shadow-card">
            <div className="grain absolute inset-0" />
            <img src={IMAGES.cargoShip} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
            <div className="absolute inset-0 bg-gradient-to-r from-brand via-brand/90 to-brand/50" />
            <div className="relative max-w-2xl">
              <h2 className="font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl leading-tight">
                Not sure which service you need?
              </h2>
              <p className="mt-4 text-white/75 text-lg">
                Share your requirement and our specialists will craft the right solution — with a transparent, no-obligation quote.
              </p>
              <div className="mt-8 flex flex-wrap gap-4">
                <CTAButton to="/#quote" variant="white">Get a Free Quote</CTAButton>
                <CTAButton to="/contact" variant="outlineLight" arrow={false}>Talk to an Expert</CTAButton>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
